module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-11.4525c652.jpg";